import script from "./MItemDaListaDeProfissionais.vue?vue&type=script&lang=ts&setup=true"
export * from "./MItemDaListaDeProfissionais.vue?vue&type=script&lang=ts&setup=true"

import "./MItemDaListaDeProfissionais.vue?vue&type=style&index=0&id=78208b06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78208b06"]])

export default __exports__